module.exports = __webpack_public_path__ + "assets/437a88c49436dbc1b88659597b58f322.mp3";